import React from "react";

type TipsProps = {
  title?: string;
  children?: React.ReactNode; // Allows for any react node to be passed as children
};

export const TipsAndResources = ({ title, children }: TipsProps) => {
  return (
    <div className="bg-neutral-0 mt-6 p-6 rounded-lg">
      <div className="flex items-center text-primary-700 text-lg font-semibold mb-4">{title}</div>
      <div className="text-primary-700 text-lg mb-4 text-left">{children}</div>
    </div>
  );
};

export default TipsAndResources;
